module.exports = __webpack_public_path__ + "static/media/birdT4.211800f9.jpg";